module.exports = __webpack_public_path__ + "img/glogin-logo.ec60da63.png";